export const selectId = (model: { sid?: string | null; id?: string | null }) => (model.sid || model.id)!;
